import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export function ParallaxImage({ src, alt, className = "", strength = 8, priority = false }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);

  return (
    <div ref={ref} className={`relative overflow-hidden bg-[#0f1f3d]/10 ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        loading={priority ? "eager" : "lazy"}
        fetchpriority={priority ? "high" : "auto"}
        decoding="async"
        className="absolute -top-[10%] left-0 h-[120%] w-full object-cover"
      />
    </div>
  );
}
